const caseDetailPage = () => {
  $('.case-detail .news-slide').slick({
    dots: true,
    arrows: false,
    infinite: false,
    variableWidth: true, //Tự động lấy theo width của section
    speed: 500,
    fade: false,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

  $('.image-slides').slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    fade: false,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
}

module.exports = caseDetailPage
